import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import GridItem from "components/Grid/GridItem.js";
import GridContainer from "components/Grid/GridContainer.js";
import { IconButton, styled } from "@material-ui/core";
import EditIcon from "@material-ui/icons/Edit";
import DeleteIcon from "@material-ui/icons/Delete";
import { formatDate } from "utils/Utils";
import ConfirmationModal from "views/components/ConfirmationModal";
import { endpoint } from "assets/api/endpoint";
import { apiHandler } from "assets/api";
import CircularProgresss from "components/CircularProgress/CircularProgresss";
import ColumnGroupingTable from "components/UpdateUi/Table/Table";
import SubHeader from "components/UpdateUi/SubHeader/SubHeader";
import { parseDate } from "utils/Utils";
import ToastModal from "views/components/ToastModal";
import { parseDateMDY } from "utils/Utils";
import { toCamelCase } from "utils/Utils";
const Ornament = () => {
  const navigate = useNavigate();
  const [rawData, setRawData] = useState([]);
  const [selectedTableData, setSelectedTableData] = useState([]);
  const [tableColumns] = useState([
    { id: "name", label: "Name" },
    { id: "minGrossWeight", label: "Min Gross Weight" },
    { id: "maxGrossWeight", label: "Max Gross Weight" },
    { id: "maxAllowedCount", label: "Max Allowed Count" },
    { id: "createdOn", label: "Created On" },
    { id: "updatedOn", label: "Updated On" },
    { id: "elegiblity", label: "Eligibility" },
    { id: "status", label: "Status" },
    {id:"action", label:"Action"}
  ]);
  const [toast, setToast] = useState(false);
  const [toastMessage, setToastMessage] = useState('');
  const [toastMessageType, setToastMessageType] = useState('');
  const [confirmationModal, setConfirmationModal] = useState(false);
  const [confirmationModalHeader, setConfirmationModalHeader] = useState("");
  const [confirmationModalMsg, setConfirmationModalMsg] = useState("");
  const [deleteRoleId, setDeleteRoleId] = useState("");
  const { authToken } = useSelector((state) => state.login.authData);
  const [callInProgress, setCallInProgress] = useState(false);
  const [selected, setSelected] = useState("environment");
  const [startScan, setStartScan] = useState(false);
  const [loadingScan, setLoadingScan] = useState(false);
  const [data, setData] = React.useState("Not Found");
  const [torchOn, setTorchOn] = React.useState(false);
  // submit create function
  const handlecreateroleSubmit = () => {
    navigate(`/coreservice/role-create`);
  };
  // message popup
  const toastUpdate = (type, message, showToast) => {
    setToastMessageType(type);
    setToastMessage(message);
      setToast(showToast);
  };
  // get api calling
  useEffect(() => {
    GetData();
  }, []);
  const GetData = async () => {
    setCallInProgress(true);
    const result = await apiHandler({
      url: endpoint.ORNAMENT_FINDALL,
      authToken: authToken,
    });
    setCallInProgress(false);
    if (result?.data?.error_code) {
      toastUpdate("Error", result?.data?.user_description, true);
    } else {
      setRawData(result?.data);
      parseIndicatorData(result?.data);
    }
  };

  // parseindicatordata function
  const parseIndicatorData = (data) => {
    let reportData = [];
    data &&
      data.forEach((role, index) => {
        let row = {
          name: role.name,
          minGrossWeight: role.minGrossWeight,
          maxGrossWeight: role.maxGrossWeight,
          maxAllowedCount:role.maxAllowedCount,
          createdOn:parseDateMDY(role.createdOn),
          updatedOn: parseDateMDY(role.updatedOn),
          elegiblity: toCamelCase(role.eligibility),
          status: toCamelCase(role.status),
          action: getIcons(role.id)
        };
        reportData.push(row);
      });
    setSelectedTableData(reportData);
  };
  // icons function
  const getIcons = (role) => {
    return (
      <>
        <IconButton
          aria-label="Edit Role"
          onClick={() => onClickUpdateData(role)}
        >
          <EditIcon />
        </IconButton>
        {/* <IconButton
          aria-label="Delete Role"
          onClick={() => onClickDeleteData(role)}
        >
          <DeleteIcon />
        </IconButton> */}
      </>
    );
  };
  // update function
  const onClickUpdateData = (role) => {
    navigate(`/coreservice/ornament-create/` + role);
  };
  // delete function
  const onClickDeleteData = (role) => {
    setConfirmationModalHeader("Role");
    setConfirmationModalMsg("Are you sure you want to delete this entry");
    setDeleteRoleId(role);
    setConfirmationModal(true);
  };
  const handleNegativeResponse = () => {
    setConfirmationModal(false);
    setConfirmationModalHeader("");
    setConfirmationModalMsg("");
    setDeleteRoleId("");
  };
  const handlePositiveResponse = async () => {
    const roleid = deleteRoleId;
    handleNegativeResponse();
    setCallInProgress(true);
    // Call API to delete Role
    const res = await apiHandler({
      url: endpoint.MASTER_ROLE_DELETE + roleid + "?role=" + roleid,
      method: "DELETE",
      authToken: authToken,
    });
    setCallInProgress(false);
    if (res?.data?.error_code) {
      toastUpdate("Error", res?.data?.user_description, true);
    } else {
      toastUpdate("Success", "Delete Ornament is successfully", true);
      GetData();
    }
  };

  // serach function
  const onSearchChange = (event) => {
    const filteredData = rawData.filter((row) => {
      const val = event.target.value;
      const createDate = formatDate(row.createdDate);
      const updatedDate = formatDate(row.updatedDate);
      return (
        row.name?.toLowerCase()?.includes(val?.toLowerCase()) 
      );
    });
    parseIndicatorData(filteredData);
  };
  const handleCreateOrnament = () => {
    navigate(`/coreservice/ornament-create`);
  };
  const handleScan = async (scanData) => {
    setLoadingScan(true);
    if (scanData && scanData !== "") {
      setData(scanData);
      setStartScan(false);
      setLoadingScan(false);
      // setPrecScan(scanData);
    }
  };
  const handleError = (err) => {
    console.error("loaded data data");
    console.error("loaded data data",err);
  };
  return (
    <>
    <GridContainer>
      <GridItem xs={12} sm={12} md={12}>
        <SubHeader
          label=" Ornament Master"
          button1="Create"
          button1click={handleCreateOrnament}
          onSearchChange={onSearchChange}
          searchLabel = "Search For Ornament"
          search
        />
      </GridItem>
      <GridItem xs={12} sm={12} md={12}>
        <ColumnGroupingTable columns={tableColumns} rows={selectedTableData} />
      </GridItem>
      {toast && (
          <ToastModal
            toastMessage={toastMessage}
            toastMessageType={toastMessageType}
            toastUpdate={toastUpdate}
          />
        )}
      {callInProgress && <CircularProgresss callInProgress={callInProgress} />}
      <ConfirmationModal
        confirmationModal={confirmationModal}
        confirmationModalHeader={confirmationModalHeader}
        confirmationModalMsg={confirmationModalMsg}
        handleNegativeButton={handleNegativeResponse}
        handlePositiveButton={handlePositiveResponse}
      />
    </GridContainer>
 </> 
  );
};

export default Ornament;
